export const TemplatesTypesEnum = {
  Email: {
    key: 2,
    icon: 'icons i-email-tag',
    backgroundColor: 'bg-email-gradient',
    value: 'email',
    valueShort: 'email-short',
  },
  SMS: {
    key: 1,
    icon: 'icons i-sms-tag',
    backgroundColor: 'bg-sms-gradient',
    value: 'sms',
    valueShort: 'sms-short',
  },
  Whatsapp: {
    key: 3,
    icon: 'icons i-whatsapp-tag',
    backgroundColor: 'bg-whatsapp-gradient',
    value: 'whatsapp',
    valueShort: 'wapp',
  },
};
